import { render, staticRenderFns } from "./AddShop.vue?vue&type=template&id=971abe8a&scoped=true"
import script from "./AddShop.vue?vue&type=script&lang=js"
export * from "./AddShop.vue?vue&type=script&lang=js"
import style0 from "./AddShop.vue?vue&type=style&index=0&id=971abe8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971abe8a",
  null
  
)

export default component.exports